import { makeAutoObservable, runInAction } from 'mobx'
import { memberMobx } from '../rootMobx'
import { toast } from '../../common/utils'
import { find } from '@dt/fe-utils/dist/lodash'
import ActivityApi from 'api/activity.api'
import { ddayjs } from '@dt/fe-utils'

class ActivityStore {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  bindMobileActive: any = null
  lotteryList: any[] = []

  async initData () {
    this.lotteryList = []
  }

  async getEntryActive () {
    let res: any
    try {
      res = await ActivityApi.getEntryActiveActivity()
    } catch (error) { }
    runInAction(() => {
      res && (this.bindMobileActive = find(res, (item: any) => item.type === 'bindMobileSendCoupon' && item.status === 'enable' && ddayjs(item.endTime).valueOf() > Date.now()))
      res && (this.lotteryList = res.filter((item: any) => item.type === 'prizeCoupon' && item.status === 'enable' && ddayjs(item.endTime).valueOf() > Date.now()))
    })
    return res
  }

  async getBindMobileActive () {
    const params = {
      type: 'bindMobileSendCoupon',
    }
    let res: any
    try {
      res = await ActivityApi.getActiveList(params)
    } catch (error) { }
    runInAction(() => {
      res && (this.bindMobileActive = find(res, (item: any) => item.type === 'bindMobileSendCoupon' && item.status === 'enable' && ddayjs(item.endTime).valueOf() > Date.now()))
    })
    return res
  }

  async getLuckyActive () {
    const params = {
      type: 'prizeCoupon',
    }
    let res: any
    try {
      res = await ActivityApi.getActiveList(params)
    } catch (error) { }
    runInAction(() => {
      res && (this.lotteryList = res.filter((item: any) => item.status === 'enable' && ddayjs(item.endTime).valueOf() > Date.now()))
    })
    return res
  }

  async getPrizeCoupon (para?: any) {
    const params = {
      brandId: memberMobx.brandId,
      ...para,
    }
    let res: any
    try {
      res = await ActivityApi.getPrizeCoupon(params)
    } catch (error) { }
    runInAction(() => {
      res && (this.lotteryList = res)
    })
    return res
  }

  async getActiveDetail (activityId: number) {
    let res: any
    try {
      res = await ActivityApi.getActiveDetail(activityId)
      if (res.status === 'disable' || ddayjs().valueOf() > ddayjs(res.endTime).valueOf()) {
        res.isOver = true
        toast({ message: i18n.t('mkt.market.eventIsOver') })
      }
    } catch (error) {
      toast({ message: i18n.t('mkt.market.activityNotExist') })
    }
    return res
  }
}

export default new ActivityStore()
